export const DEFAULT_FIXED_DIGITS = 2

export function ratioFromTotal(num: number, total: number) {
  return num / total
}

export function formatAmount(
  amount: number | string,
  fixedDigits: number = DEFAULT_FIXED_DIGITS,
  suffix = '',
) {
  if (typeof amount === 'number' && !amount) {
    return `0${suffix}`
  }

  if (!amount) {
    return 'NaN'
  }

  const amountVal = parseFloat(String(amount).replace(',', '.'))

  if (Number.isNaN(amountVal)) {
    return 'NaN'
  }

  const powerOf10 = 10 ** fixedDigits

  const amountValFixedDigits = !Number.isInteger(amountVal)
    ? Math.round(amountVal * powerOf10) / powerOf10
    : amountVal

  const value = amountValFixedDigits.toFixed(fixedDigits)

  return `${value.replace('.', ',')}${suffix}`
}

export function formatFee(price: number | string, fixedDigits = DEFAULT_FIXED_DIGITS) {
  return formatAmount(price, fixedDigits, ' €')
}

export function formatBytes(bytes: number, precision = 2, defaultZeroUnit = 'MB') {
  if (bytes === 0) return `0 ${defaultZeroUnit}`
  const positivePrecision = Math.max(precision, 0)
  const units = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
  const properUnit = Math.floor(Math.log(bytes) / Math.log(1024))
  return `${parseFloat((bytes / 1024 ** properUnit).toFixed(positivePrecision))} ${
    units[properUnit]
  }`
}

export function formatMinutes(sec: number): string {
  if (!sec) return '0 Min'
  if (sec === 0) return 'Infinitos'
  return `${Math.floor(sec / 60)} Min`
}
